export default {"src":"/_next/static/media/Upload.96ae7dfe.svg","height":16,"width":16};